import { Button } from '../ui/button'
import { TabsHeader, TabsHeaderActions, TabsHeaderTitle } from '../ui/tabs'
import { FilterControls, type FilterControlsProps } from './AddressesFilterControls'
import { Plus } from 'lucide-react'

export interface AddressesHeaderProps extends Omit<FilterControlsProps, 'className'> {
  title?: string
  onAddClick: () => void
  addButtonText?: string
  className?: string
}

export function AddressesHeader({
  title = 'Whitelisted Addresses',
  onAddClick,
  addButtonText = 'Add',
  statusFilter,
  chainFilter,
  onStatusFilterChange,
  onChainFilterChange,
  statusOptions,
  chainOptions,
  className = '',
}: AddressesHeaderProps) {
  const headerContent = (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2 md:gap-0">
      <TabsHeaderTitle>{title}</TabsHeaderTitle>
      <TabsHeaderActions className="items-center">
        <FilterControls
          statusFilter={statusFilter}
          chainFilter={chainFilter}
          onStatusFilterChange={onStatusFilterChange}
          onChainFilterChange={onChainFilterChange}
          statusOptions={statusOptions}
          chainOptions={chainOptions}
        />
      </TabsHeaderActions>
    </div>
  )

  const addButton = (
    <div className="flex items-center gap-4">
      <Button onClick={onAddClick} variant="main_action" className="px-6">
        <Plus className="h-3 md:h-4 w-3 md:w-4" />
        {addButtonText}
      </Button>
    </div>
  )

  return (
    <TabsHeader className={className}>
      {headerContent}
      {addButton}
    </TabsHeader>
  )
}
